var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('ul',_vm._l((_vm.footerLinkItems),function(item){return _c('li',{key:item.id},[_c('a',{staticClass:"footer-link",attrs:{"href":item.url,"target":item.blank ? '_blank' : false}},[_vm._v(_vm._s(item.name))])])}),0),_vm._v(" "),_c('small',[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" Lisse")])])
}
var staticRenderFns = []

export { render, staticRenderFns }